import React from 'react';
import type { LabelProps as FormLabelPropsDS } from '@gov-design-system-ce/react-form';
import { FormLabel as FormLabelDS } from '@gov-design-system-ce/react-form';

export interface FormLabelProps extends Omit<
	FormLabelPropsDS,
	'classNames' | 'children'
> {}

// TODO: Remove the className after gov-design-system-ce/components@4.5.2 is released

export const FormLegend = (props: React.PropsWithChildren<FormLabelProps>) => (
	<FormLabelDS
		{...props}
		size="l"
		isLegend
		className="mb-0! text-body-l!">
		{props.children}
	</FormLabelDS>
);
